import { addDays, startOfDay, startOfWeek } from "@app/core";

import type { MultiDayFocus } from "../../stores/settings.store.js";

export function multiDayFocusAnchor(
  date: Date,
  focus: MultiDayFocus,
  weekStartsOn: 0 | 1,
): Date {
  const today = startOfDay(date);
  if (focus === "current_week") return startOfDay(startOfWeek(today, { weekStartsOn }));
  if (focus === "current_day_minus_one") return addDays(today, -1);
  return today;
}

/** Advance only a window that was still following its prior default. */
export function rollMultiDayFocusAnchor(
  anchor: Date,
  previousDay: Date,
  currentDay: Date,
  focus: MultiDayFocus,
  weekStartsOn: 0 | 1,
): Date {
  const previousDefault = multiDayFocusAnchor(previousDay, focus, weekStartsOn);
  if (startOfDay(anchor).getTime() !== previousDefault.getTime()) return anchor;
  return multiDayFocusAnchor(currentDay, focus, weekStartsOn);
}
